import {
  List,
  Datagrid,
  TextField,
  NumberField,
  CreateButton,
  ExportButton,
  TopToolbar,
  TextInput,
  Filter,
} from "react-admin";
import {
  Box,
  Tooltip,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";

import CustomDateField from "../components/CustomDateField";
import useImport from "../../../hooks/useImport";
import SFImagefield from "../../../components/SFImageField";
import useDataGridStyles from "../components/DataGridStyle";
import LayoutContainer from "../components/LayoutContainer";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
import exporter from "../../../utils/exporter";
import useSFLoading from "../../../hooks/useSFLoading";
import useSFSuccess from "../../../hooks/useSFSuccess";
import useSFAlert from "../../../hooks/useSFAlert";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { ReactComponent as ImportIcon } from "../../../assets/icons/Import.svg";
import { ReactComponent as ExportIcon } from "../../../assets/icons/Export.svg";

const ProductFilters = (props) => (
  <Filter {...props}>
    <TextInput
      label="Search"
      source="search_term_name"
      alwaysOn
      variant="outlined"
    />
  </Filter>
);

const ProductList = (props) => {
  const title = "Products";
  const headers = [
    { label: "code", source: "code" },
    { label: "Name", source: "name" },
    { label: "Price", source: "retail_price" },
    { label: "Category", source: "category.name" },
    { label: "Status", source: "status" },
    { label: "Created", source: "time" },
  ];
  const classes = useDataGridStyles();
  return (
    <LayoutContainer>
      <SfBreadcrumbs path="/Management/Products" lower />
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
        exporter={(data) => exporter(data, headers, title)}
        actions={<ListActions />}
        classes={{ content: classes.content }}
        filters={<ProductFilters />}
      >
        <>
          <Datagrid
            rowClick="show"
            classes={{ headerCell: classes.header, rowCell: classes.row }}
          >
            <SFImagefield
              source="image_url"
              normal
              square
              lower
              productListPage
            />
            <TextField label="code" source="code" />
            <TextField label="Name" source="name" />
            <NumberField label="Price" source="retail_price" />
            <TextField label="Category" source="category.name" />
            <TextField label="Status" source="status" />
            {/* <DateField label="Created" source="time" showTime /> */}
            <CustomDateField label="Created" source="time" />
          </Datagrid>
        </>
      </List>
      <PermissionChecker code="Page.Merchant.Management.Product" />
    </LayoutContainer>
  );
};
const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },
  faceImage: {
    color: theme.palette.primary.light,
    maxHeight: 15,
    maxWidth: 15,
    padding: 0,
  },
}));
// const ColorButton = withStyles((theme) => ({
//   root: {
//     fontSize: 14,
//     color: "white",
//     backgroundColor: orange[500],
//     '&:hover': {
//       backgroundColor: orange[600],
//     },
//     borderRadius: 50
//   },
// }))(Button);
const ListActions = (props) => {
  const classes = useStyles();
  const [showLoading, hideLoading] = useSFLoading();
  const [showSuccess] = useSFSuccess();
  const [alert] = useSFAlert();
  const { importFile } = useImport();

  const handleCapture = async ({ target }) => {
    //setSelectedFile(target.files[0]);

    showLoading();
    const [, error] = await importFile({
      file: target.files[0],
    });
    if (error) {
      const message =
        error || error.message ? error.message : "Error: Something went wrong.";
      alert(JSON.stringify(message));
    } else {
      showSuccess();
    }
    hideLoading();
    target.value = null; //Make able to repeat same file
  };
  return (
    <TopToolbar>
      <CreateButton icon={<AddCircleIcon />} label="Add product" />
      <ExportButton
        icon={<ExportIcon width={20} height={20} />}
        label={"Export"}
      />
      {/* Add your custom actions */}
      <Box style={{ marginTop: 4, paddingRight: 30, paddingLeft: 10 }}>
        <input
          accept="*/*"
          className={classes.input}
          id="faceImage"
          type="file"
          onChange={handleCapture}
        />

        <Tooltip title="Import File">
          <label htmlFor="faceImage">
            <IconButton
              className={classes.faceImage}
              color="primary"
              aria-label="upload picture"
              component="span"
            >
              <ImportIcon width={20} height={20} />
            </IconButton>
            <Typography
              variant="caption"
              color="primary"
              style={{ marginLeft: 8, fontSize: "13px", fontWeight: 500 }}
            >
              Import
            </Typography>
          </label>
        </Tooltip>
      </Box>
    </TopToolbar>
  );
};

/**
 * <ReferenceManyField
          label="Amount"
          target="product_id"
          reference="stock"
        >
          <SingleFieldList>
            <ChipField source="remaining" />
          </SingleFieldList>
        </ReferenceManyField>
 */
export default ProductList;
